import { useRef, useEffect, useCallback } from "react";
import cn from "classnames";

import { CloseX } from "@icons";

import { useMapDrawer } from "@pageComponents/itineraries/mapDrawer/context";
import { MapWrapper } from "@pageComponents/itineraries/mapDrawer/wrapper";

export function MapDrawer() {
  const drawerRef = useRef(null);
  const { open, setOpen, pois } = useMapDrawer();

  const handleOutsideClick = useCallback(
    e => {
      if (drawerRef.current && !drawerRef.current.contains(e.target)) {
        setOpen(false);
      }
    },
    [setOpen]
  );

  useEffect(() => {
    if (open) {
      document.addEventListener("click", handleOutsideClick);
    }

    return () => document.removeEventListener("click", handleOutsideClick);
  }, [open, handleOutsideClick]);

  return (
    <aside
      className={cn(
        "fixed left-0 bottom-0 z-40 w-full h-screen shadow-lg transition-opacity bg-transparent-80",
        open ? "visible opacity-100" : "invisible opacity-0"
      )}
    >
      <div
        className={cn(
          "absolute bottom-0 left-0 w-full h-screen-4/5 md:h-screen-2/3 bg-white transition-transform delay-150",
          {
            "translate-y-full": !open,
          }
        )}
        ref={drawerRef}
      >
        <div className="h-full p-8 mb-8 relative">
          <button
            type="button"
            className="absolute top-0 right-0 mr-10 -translate-y-full h-10 rounded-t flex items-center gap-2 bg-white px-4 text-sm font-semibold"
            onClick={() => setOpen(false)}
          >
            <CloseX className="text-sm" /> Close map
          </button>

          <MapWrapper points={pois} />
        </div>
      </div>
    </aside>
  );
}
